import React from 'react';

import {
  PersonalFormComponentInterface,
  EnumNamesInputs,
} from '../../types/form.types';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

import HeaderText from '../HeaderText/headerText.component';
import MaskedInput from '../MaskedInput/MaskedInput';

import { Grid } from '@creditas/layout';
import { Button } from '@creditas/button';
import {
  Layout,
  ButtonContainer,
  FormLink,
  FormFooter,
  RGridItem,
  FormContainer,
  SideBar,
  Container,
} from './form.styles';
import { Typography } from '@creditas/typography';
import ErrorInput from '../ErrorInput/errorInput';

const PersonalInfoComponent: React.FC<PersonalFormComponentInterface> = (
  props: PersonalFormComponentInterface,
) => {
  const {
    handleChangeInput,
    handleNamesChange,
    names,
    firstLastname,
    secondLastname,
    rfc,
    errors,
    email,
    phone,
    handleSubmit,
    birthDate,
    isLoading,
  } = props;
  const autoCorrectedDateMask = createAutoCorrectedDatePipe('dd/mm/yyyy');
  const maskInfoUser = (value: string): Array<RegExp> => {
    const valueSplit = value === undefined ? '' : value.split('');
    const mask = [];
    for (let i = -1; i <= valueSplit.length; i++) {
      mask.push(/[A-Za-zÀ-ÿ´ ]/);
    }
    return mask;
  };
  return (
    <Container>
      <SideBar>
        <HeaderText
          text={'Consulta de historial crediticio'}
          description={
            'Para consultar tu historial necesitamos que llenes este formulario.'
          }
        />
      </SideBar>
      <FormContainer>
        <Layout container>
          <Grid
            item
            colStart={1}
            colEnd={8}
            mdColStart={1}
            mdColEnd={8}
            lgColStart={1}
            lgColEnd={12}
          >
            <HeaderText
              text={'Datos personales'}
              description={
                'Para consultar tu historial necesitamos que llenes este formulario:'
              }
            />
          </Grid>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={1}
            mdColEnd={4}
            lgColStart={1}
            lgColEnd={6}
          >
            <MaskedInput
              mask={maskInfoUser(names)}
              guide={false}
              id={EnumNamesInputs.NAMES}
              name={EnumNamesInputs.NAMES}
              value={names}
              label={'Nombre(s)*'}
              placeholder={'Escribe tu(s) nombre(s)'}
              onChange={handleNamesChange}
              error={errors && !!errors[EnumNamesInputs.FIRST_NAME]}
              feedbackText={
                errors && errors[EnumNamesInputs.FIRST_NAME]
                  ? errors[EnumNamesInputs.FIRST_NAME][0]
                  : undefined
              }
            />
          </RGridItem>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={1}
            mdColEnd={4}
            lgColStart={1}
            lgColEnd={6}
          >
            <MaskedInput
              mask={maskInfoUser(firstLastname)}
              guide={false}
              id={EnumNamesInputs.FIRST_LAST_NAME}
              name={EnumNamesInputs.FIRST_LAST_NAME}
              value={firstLastname}
              label={'Apellido paterno*'}
              placeholder={'Escribe tu apellido paterno'}
              onChange={handleChangeInput}
              error={errors && !!errors[EnumNamesInputs.FIRST_LAST_NAME]}
              feedbackText={
                errors && errors[EnumNamesInputs.FIRST_LAST_NAME]
                  ? errors[EnumNamesInputs.FIRST_LAST_NAME][0]
                  : undefined
              }
            />
          </RGridItem>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={5}
            mdColEnd={4}
            lgColStart={7}
            lgColEnd={6}
          >
            <MaskedInput
              mask={maskInfoUser(secondLastname)}
              guide={false}
              id={EnumNamesInputs.SECOND_LAST_NAME}
              name={EnumNamesInputs.SECOND_LAST_NAME}
              value={secondLastname}
              label={'Apellido materno*'}
              placeholder={'Escribe tu apellido materno'}
              onChange={handleChangeInput}
              error={errors && !!errors[EnumNamesInputs.SECOND_LAST_NAME]}
              feedbackText={
                errors && errors[EnumNamesInputs.SECOND_LAST_NAME]
                  ? errors[EnumNamesInputs.SECOND_LAST_NAME][0]
                  : undefined
              }
            />
          </RGridItem>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={1}
            mdColEnd={4}
            lgColStart={1}
            lgColEnd={6}
          >
            <MaskedInput
              mask={[
                /\d/,
                /\d/,
                '/',
                /\d/,
                /\d/,
                '/',
                /[1-2]/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              pipe={autoCorrectedDateMask}
              guide={false}
              keepCharPositions={true}
              id={EnumNamesInputs.BIRTH_DATE}
              name={EnumNamesInputs.BIRTH_DATE}
              label={'Fecha de nacimiento*'}
              placeholder={'dd/mm/aaaa'}
              onChange={handleChangeInput}
              value={birthDate}
              error={errors && !!errors[EnumNamesInputs.BIRTH_DATE]}
              feedbackText={
                errors && errors[EnumNamesInputs.BIRTH_DATE]
                  ? errors[EnumNamesInputs.BIRTH_DATE][0]
                  : undefined
              }
            />
          </RGridItem>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={5}
            mdColEnd={4}
            lgColStart={7}
            lgColEnd={6}
          >
            <MaskedInput
              mask={[
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
                /[A-Za-z-0-9]/,
              ]}
              guide={false}
              id={EnumNamesInputs.RFC}
              name={EnumNamesInputs.RFC}
              placeholder={'RAGL232323R23'}
              label={'RFC*'}
              value={rfc.toUpperCase()}
              onChange={handleChangeInput}
              error={errors && !!errors[EnumNamesInputs.RFC]}
              feedbackText={
                errors && errors[EnumNamesInputs.RFC]
                  ? errors[EnumNamesInputs.RFC][0]
                  : undefined
              }
            />
          </RGridItem>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={1}
            mdColEnd={4}
            lgColStart={1}
            lgColEnd={6}
          >
            <ErrorInput
              id={EnumNamesInputs.EMAIL}
              name={EnumNamesInputs.EMAIL}
              label={'Correo electrónico*'}
              placeholder={'Escribe tu correo electrónico'}
              value={email}
              onChange={handleChangeInput}
              error={errors && !!errors[EnumNamesInputs.EMAIL]}
              feedbackText={
                errors && errors[EnumNamesInputs.EMAIL]
                  ? errors[EnumNamesInputs.EMAIL][0]
                  : undefined
              }
            />
          </RGridItem>
          <RGridItem
            item
            colStart={1}
            colEnd={8}
            mdColStart={5}
            mdColEnd={4}
            lgColStart={7}
            lgColEnd={6}
          >
            <MaskedInput
              mask={[
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              guide={false}
              id={EnumNamesInputs.PHONE_NUMBER}
              name={EnumNamesInputs.PHONE_NUMBER}
              label={'Teléfono móvil*'}
              placeholder={'Escribe tu teléfono móvil'}
              onChange={handleChangeInput}
              value={phone}
              error={errors && !!errors[EnumNamesInputs.PHONE_NUMBER]}
              feedbackText={
                errors && errors[EnumNamesInputs.PHONE_NUMBER]
                  ? errors[EnumNamesInputs.PHONE_NUMBER][0]
                  : undefined
              }
            />
          </RGridItem>
        </Layout>
        <FormFooter container>
          <Grid item colStart={1} colEnd={6}>
            <Typography variant={'paragraph'}>
              <label className={'obligatory'}>{'* Campo obligatorio'}</label>
            </Typography>
          </Grid>
          <Grid item colStart={1} colEnd={12}>
            <Typography variant={'paragraph'}>
              <span>Al dar clic en CONTINUAR aceptas nuestro </span>
              <FormLink
                href={'https://www.creditas.mx/legal/aviso-privacidad'}
                target={'_blank'}
              >
                Aviso de privacidad
              </FormLink>
              {', '}
              <FormLink
                href={'https://www.creditas.mx/legal/terminos-condiciones'}
                target={'_blank'}
              >
                Términos y Condiciones
              </FormLink>
              {'.'}
            </Typography>
          </Grid>
        </FormFooter>
        <ButtonContainer>
          <Button
            onClick={handleSubmit}
            type="submit"
            disabled={isLoading}
            isLoading={isLoading}
          >
            Continuar
          </Button>
        </ButtonContainer>
      </FormContainer>
    </Container>
  );
};

export default PersonalInfoComponent;
